import type { ConsentCategories } from "@guru/shared/consent";
import posthog from "posthog-js";

// Session-replay masking: never record sensitive tenant fields.
export const MASK_TEXT_SELECTOR =
  "[data-private], [type=email], [type=tel], .parent-contact, .student-name";

let initialised = false;

/**
 * Applies the current consent decision to PostHog: initialise + opt-in only when
 * analytics is granted, gate session replay separately, opt-out otherwise.
 */
export function applyConsent(categories: ConsentCategories): void {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!key) return;

  if (!categories.analytics) {
    if (initialised) posthog.opt_out_capturing();
    return;
  }

  if (!initialised) {
    posthog.init(key, {
      api_host: "/ingest",
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: "2025-11-30",
      capture_exceptions: true,
      disable_session_recording: !categories.sessionReplay,
      enable_recording_console_log: categories.sessionReplay,
      session_recording: { maskAllInputs: true, maskTextSelector: MASK_TEXT_SELECTOR },
    });
    initialised = true;
  } else {
    posthog.opt_in_capturing();
  }

  if (categories.sessionReplay) {
    posthog.startSessionRecording();
  } else {
    posthog.stopSessionRecording();
  }
}
